import { Dispatch, SetStateAction } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Arrow, Button } from 'coreOld/components';
import { HeaderModalOptions } from 'coreOld/constants';

import {
  ButtonWrapper,
  ContentWrapper,
  SubTitle,
  Title,
  VersionDecoration,
  VersionTitle,
  VersionWrapper,
  Wrapper,
  buttonStyle,
} from './requestHomeStyle';

interface IProps {
  openAuthModal: Dispatch<SetStateAction<HeaderModalOptions>>;
}

const RequestHomeView = ({ openAuthModal }: IProps) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <ContentWrapper>
        <VersionWrapper>
          <VersionDecoration />

          <VersionTitle>{t('labelVersion')}</VersionTitle>
        </VersionWrapper>

        <Title>
          <Trans i18nKey="titleTssAtsSupportRequest" />
        </Title>

        <SubTitle>
          <Arrow />

          <Trans i18nKey="messageClickToCreateRequest" components={[<span key="userName" />]} />
        </SubTitle>

        <ButtonWrapper key={0} to="#" onClick={() => openAuthModal(HeaderModalOptions.SIGN_IN)}>
          <Button style={buttonStyle} fullHeight fullWidth>
            {t('buttonLabelCreateNewSupportRequest')}
          </Button>
        </ButtonWrapper>
      </ContentWrapper>
    </Wrapper>
  );
};

export default RequestHomeView;
